import Stack from "@mui/material/Stack";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import ListSubheader from "@mui/material/ListSubheader";
import Switch from "@mui/material/Switch";
import { useAppStore } from "../../store/appStore";

const Options = () => {
	const top30VoteTrendsMeshOrSlices = useAppStore(
		(state) => state.top30VoteTrendsMeshOrSlices
	);
	const setTop30VoteTrendsMeshOrSlices = useAppStore(
		(state) => state.setTop30VoteTrendsMeshOrSlices
	);
	const top30VoteTrendsSlicesSortEnabled = useAppStore(
		(state) => state.top30VoteTrendsSlicesSortEnabled
	);
	const setTop30VoteTrendsSlicesSortEnabled = useAppStore(
		(state) => state.setTop30VoteTrendsSlicesSortEnabled
	);

	const handleChange = (event) => {
		if (event.target.name === "top30VoteTrendsMeshOrSlices") {
			setTop30VoteTrendsMeshOrSlices(event.target.checked ? "slices" : "mesh");
		} else if (event.target.name === "top30VoteTrendsSlicesSortEnabled") {
			setTop30VoteTrendsSlicesSortEnabled(event.target.checked);
		}
	};

	return (
		<List subheader={<ListSubheader component="div">圖表選項</ListSubheader>}>
			<ListItem dense>
				<ListItemText primary="票數顯示" />
				<Stack direction="row" spacing={1} alignItems="center">
					<Typography>單獨</Typography>
					<Switch
						checked={top30VoteTrendsMeshOrSlices === "slices"}
						onChange={handleChange}
						name="top30VoteTrendsMeshOrSlices"
					/>
					<Typography>所有</Typography>
				</Stack>
			</ListItem>
			{top30VoteTrendsMeshOrSlices === "slices" && (
				<ListItem dense>
					<ListItemText primary="排序" />
					<Stack direction="row" spacing={1} alignItems="center">
						<Typography>號碼</Typography>
						<Switch
							checked={top30VoteTrendsSlicesSortEnabled}
							onChange={handleChange}
							name="top30VoteTrendsSlicesSortEnabled"
						/>
						<Typography>票數</Typography>
					</Stack>
				</ListItem>
			)}
		</List>
	);
};

export default Options;
